import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

const Robustand = () => {
  return (
    <div className="Robustand p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <h2>Our Proficient IP Protection Services</h2>
                        <p>Elevate the security of your intellectual assets with TekRevol's comprehensive IP protection services. Our expertise is efficient in delivering value-driven solutions that secure your innovations and creative works. That’s how you can ensure the credibility of your online business assets to have a remarkable presence. Explore the excellence of our services:</p>
                      
                  <Link to="/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact">Contact Us for IP Protection</Link>
                    </Col>
                    <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
                        <div className="robustscroll">
                        <div className="robust-box">
                            <div className="robust-content">
                                <h4>Trademark Registration</h4>
                                <p>Ensure the unique identity of your brand with our meticulous trademark registration services. We navigate the legal landscape to secure your trademarks with authorization. As a result, you can fortify your brand presence and protect it from unauthorized use.</p>
                            </div>
                            <div className="robust-content">
                                <h4>Trademark Monitoring</h4>
                                <p>Stay alert in the market with our proactive trademark monitoring services. We employ advanced tracking mechanisms to swiftly detect intellectual theft. That’s how we address any potential infringement, safeguarding your brand reputation and market position.</p>
                            </div>
                            <div className="robust-content">
                                <h4>Copyright Registration</h4>
                                <p>Secure your creative works with our seamless copyright registration services. We guide you through the process, securing legal protection for your artistic, literary, and musical creations. Therefore, you can maintain an environment of innovation without compromise.</p>
                            </div>
                            <div className="robust-content">
                                <h4>Utility Patent</h4>
                                <p>Secure your unique concepts and technological advancements with our utility patent services. Our experts guide you through the complex patenting process. We ensure that your innovations remain protected, giving you a competitive edge in the market.</p>
                            </div>
                        </div>
                        </div>
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Robustand